export class Patient {
	public title: string = null;
	public firstName: string;
	public surName: string;
	public name : string;
	public sex: string = null;
	public dateOfBirth: any;
	public countryOfBirth: any = null;
	public address1: string;
	public address2: string;
	public address : string;
	public phone: string;
	public country: any = null;
	public email: string;
    public occupation: any = null;
    public passportOrIdNumber: string;
}

export class SelectedModel {
	public id:any;
	public name:any;
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/patient/patient.model.ts